import React, { FC } from 'react';
import Picture from '../../../@shared/picture';
import { THeaderProps } from '../../types/splashComponent.types';

const Header: FC<THeaderProps> = ({ model }) => {
  return (
    <div className="splash-component-header splash-component__container">
      <Picture
        editorialImageProps={{
          desktopImage: model.headerLogo,
          cssClassPictureEl: 'splash-component-header__picture',
          cssClassImageEl: 'splash-component-header__logo'
        }}
      />
    </div>
  );
};

export default Header;
